// A rider who comes back (app reopened, map) with a ride in progress goes straight to it.
import type { TripView } from "../../shared/api";
import { api } from "../api";

/** The rider's ride in progress, or null (signed out, none, or Pony unreachable: stay put). */
export async function ongoingTrip(me: { id: string } | null): Promise<TripView | null> {
  if (!me) return null;
  return api.get<TripView>("/trips/current").catch(() => null);
}
